import React from 'react';
import { Container, Message, Phone, Email, Image, LinkList, LinkItem, DescriptionText, HoursText } from './styles';
import telephone from '../../../../assets/images/telephone.svg';
import calendar from '../../../../assets/images/calendar.svg';

interface SACProps {
  phone?: string;
  email?: string;
  links?: { label?: string; url: string }[];
  serviceDescription?: string;
  openingHours?: string;
}

const BasicServiceItem = ({ phone, email, links, serviceDescription, openingHours }: SACProps): JSX.Element => {
  return (
    <Container>
      {(phone || email) && <Image src={telephone} alt="telefone" />}
      {serviceDescription && <DescriptionText>{serviceDescription}</DescriptionText>}
      {(phone || email) && (
        <Message>Para mais informações, você pode entrar em contato por telefone ou e-mail:</Message>
      )}
      {phone && <Phone>{phone}</Phone>}
      {email && <Email>{email}</Email>}

      {openingHours && (
        <HoursText>
          <img
            src={calendar}
            alt="calendário"
            style={{
              width: '20px',
              height: '20px',
              filter:
                'brightness(0) saturate(100%) invert(67%) sepia(0%) saturate(18%) hue-rotate(185deg) brightness(91%) contrast(92%)',
            }}
          />
          Horário de funcionamento: {openingHours}
        </HoursText>
      )}

      {links && links.length > 0 && (
        <>
          <Message>Conheça mais em:</Message>
          <LinkList>
            {links.map((item, index) => {
              let link;
              try {
                link = typeof item === 'string' ? JSON.parse(item) : item;
              } catch (e) {
                link = { label: '', url: item };
              }
              return (
                <LinkItem key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.label || link.url.replace(/^https?:\/\//, '').replace(/\/$/, '') || 'Link'}
                </LinkItem>
              );
            })}
          </LinkList>
        </>
      )}
    </Container>
  );
};

export default BasicServiceItem;
